import React from 'react';
import { Box } from '@mantine/core';
import { spotlightSelectFirst } from '@/lib/spotlight/spotlight.store';
import { IconSearchOff } from '@tabler/icons-react';
import type { TypeNavNode, TypeSearchHit } from '@/types/ui/types.ui.navigation';
import { ENTITY_ICON } from './entity.icon';
import SpotlightEmpty from './Spotlight.Empty';
import SpotlightRow from './Spotlight.Row';

type Props = {
    query: string;
    hits: TypeSearchHit[];
    onEnter: (node: TypeNavNode) => void;
    onOpen: (path: string) => void;
};

const SpotlightResults: React.FC<Props> = ({ query, hits, onEnter, onOpen }) => {
    React.useEffect(() => {
        const frame = requestAnimationFrame(() => spotlightSelectFirst());
        return () => cancelAnimationFrame(frame);
    }, [query, hits.length]);

    if (hits.length === 0) {
        return (
            <SpotlightEmpty
                icon={IconSearchOff}
                title={`Niente per "${query}"`}
                body="Cerca una pagina (rotte, limiti, dispositivi…) o un'entità: un servizio, una chiave, un utente, un origin."
            />
        );
    }

    return (
        <Box py={4}>
            {hits.map((hit) => {
                if (hit.type === 'page') {
                    const isBranch = Boolean(hit.node.children?.length);
                    return (
                        <SpotlightRow
                            key={`page-${hit.node.id}`}
                            icon={hit.node.icon}
                            label={hit.node.label}
                            hint={hit.node.description}
                            trail={hit.trail.slice(0, -1).map((node) => node.label)}
                            branchId={isBranch ? hit.node.id : undefined}
                            onSelect={() => (hit.node.expandOnly ? onEnter(hit.node) : onOpen(hit.node.path))}
                            closeOnSelect
                            tone="brand"
                        />
                    );
                }
                return (
                    <SpotlightRow
                        key={`entity-${hit.entity.id}`}
                        icon={ENTITY_ICON[hit.entity.kind]}
                        label={hit.entity.label}
                        hint={hit.entity.hint}
                        trail={hit.trail.map((node) => node.label)}
                        onSelect={() => onOpen(hit.entity.path)}
                        closeOnSelect
                    />
                );
            })}
        </Box>
    );
};

export default SpotlightResults;
